// -------------------------import images---------------------
import avatar1 from "./Assets/Images/avatar1.jpg";
import avatar2 from "./Assets/Images/avatar2.jpg";
export const ChairmanData = [
  {
    id: 1,
    img: avatar1,
    name: "MR. FAKE NAME",
    designation: "The Chief Executive Officer (CEO) of PTC",
  },
  {
    id: 1,
    img: avatar2,
    name: "MR. FAKE NAME TWO",
    designation: "Managing Director (MD) of PTC",
  },
];
